// FastAPI details can be a string or an object. Rendering the object straight
// into JSX crashes the funnel, so unwrap before displaying.
export function errorMessage(err, fallback = "Something went wrong. Please try again.") {
  const detail = err?.response?.data?.detail;
  if (typeof detail === "string" && detail) return detail;
  if (detail && typeof detail === "object" && detail.message) return detail.message;
  return fallback;
}

export function errorCode(err) {
  const detail = err?.response?.data?.detail;
  return detail && typeof detail === "object" ? detail.code : null;
}
